module.exports = __webpack_public_path__ + "static/media/errIcon.6aa79fb6.svg";